import { InjectionToken, Provider } from '@angular/core';
import { PublicAuthProvider } from '@iwentsourcing/core/authentication/public-auth-providers.js';

export interface AuthConfig {
  unauthorizedUrl: string;
  authorizedUrl: string;
  logoUrl: string;
  tenant: string;
  realm: string;
}

export const AuthConfig = new InjectionToken<AuthConfig>(
  'iwentsourcing-auth-config',
);

export function provideIwentsourcingAuth(opts: AuthConfig): Provider {
  return {
    provide: AuthConfig,
    useValue: opts,
  };
}

// API host + provider lookup. Apps wire their own provider so `common`
// stays free of cross-project imports. management-ui binds this to its
// runtime-loaded ManagementAppConfig; todo-app provides a static host.
export interface ApiConfig {
  readonly host: string;
  getProviders(
    tenant: string,
    realm: string,
  ): Promise<Record<string, PublicAuthProvider>>;
}

export const ApiConfig = new InjectionToken<ApiConfig>(
  'iwentsourcing-api-config',
);
